import { render, staticRenderFns } from "./newProCard.vue?vue&type=template&id=2e80366a&scoped=true"
import script from "./newProCard.vue?vue&type=script&lang=js"
export * from "./newProCard.vue?vue&type=script&lang=js"
import style0 from "./newProCard.vue?vue&type=style&index=0&id=2e80366a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e80366a",
  null
  
)

export default component.exports